import { z } from "zod";

const ChangeStatusSchema = z.object({
    mark: z.nullable(z.string()).optional(),
    status: z.nullable(z.string()).optional(),
})

export { ChangeStatusSchema }
export type ChangeStatusForm = z.infer<typeof ChangeStatusSchema>